import Select from 'react-select';
import { IOpcao } from '@/shared/types/selectOption';
import { useDataTableStateStates } from '@/shared/components/tables/useDataTableState';
import { useState, useEffect, useRef } from 'react';

interface AttendanceSheetsFiltersProps {
  mesBusca: Date;
  setMesBusca: (date: Date) => void;
  filtrosStatus: IOpcao[];
  statusBusca: number;
  setStatusBusca: (v: number) => void;
  filtroResponsavel?: string;
  setFiltroResponsavel: (v?: string) => void;
  filtroEstagiario?: number;
  setFiltroEstagiario: (v?: number) => void;
  responsaveis: IOpcao[];
  estagiarios: IOpcao[];
  comFolha: boolean;
  setComFolha: (v: boolean) => void;
  permissaoCriarFolhas: boolean;
  setShowModalCriarFolhas: (v: boolean) => void;
  tableState: useDataTableStateStates;
  exibirFiltroResponsavel: boolean;
}

export function AttendanceSheetsFilters({
  mesBusca, setMesBusca,
  filtrosStatus, statusBusca, setStatusBusca,
  filtroResponsavel, setFiltroResponsavel,
  filtroEstagiario, setFiltroEstagiario,
  responsaveis, estagiarios,
  comFolha, setComFolha,
  permissaoCriarFolhas, setShowModalCriarFolhas,
  tableState,
  exibirFiltroResponsavel,
}: AttendanceSheetsFiltersProps) {
  const formatMonthValue = (date: Date) => {
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
  };

  const [inputValue, setInputValue] = useState(formatMonthValue(mesBusca));
  const isValidRef = useRef(true);

  useEffect(() => {
    if (isValidRef.current) {
      setInputValue(formatMonthValue(mesBusca));
    }
  }, [mesBusca]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;

    const monthRegex = /^\d{4}-(0[1-9]|1[0-2])$/;
    if (newValue === '' || monthRegex.test(newValue)) {
      setInputValue(newValue);
      isValidRef.current = true;

      if (monthRegex.test(newValue)) {
        const [year, month] = newValue.split('-').map(Number);
        setMesBusca(new Date(year, month - 1, 1));
      }
    }
  };

  return (
    <div className="row mb-3">
      <div className="col-md-2">
        <label htmlFor="periodo" className="col-form-label">Período:</label>
        <div className="input-group">
          {permissaoCriarFolhas && (
            <button
              type="button"
              className="btn btn-outline-secondary"
              title="Criar folhas de frequências"
              onClick={() => setShowModalCriarFolhas(true)}
            >
              Criar
            </button>
          )}
          <input type="month" className="form-control" id="periodo" value={inputValue} onChange={handleChange} />
        </div>
      </div>

      <div className="col-md-3">
        <label htmlFor="statusfolha" className="col-form-label">Status da Folha:</label>
        <select className="form-select" id="statusfolha" onChange={(e) => setStatusBusca(Number(e.target.value))} value={statusBusca} >
          <option value={0}></option>
          {filtrosStatus.map(item => (
            <option key={item.value} value={item.value}>{item.label}</option>
          ))}
        </select>
      </div>

      {exibirFiltroResponsavel &&
        responsaveis.filter((item) => Number(item.value) !== 0).length > 0 && (
        <div className="col-md-3">
          <label htmlFor="filtroresponsavel" className="col-form-label">Responsável:</label>
          <Select
            id="filtroresponsavel"
            options={responsaveis}
            value={filtroResponsavel ? responsaveis.find(a => String(a.value) == filtroResponsavel) : null}
            onChange={(option) => {
              tableState.setCurrentPage(0);
              setFiltroResponsavel(option ? String(option.value) : undefined);
            }}
          />
        </div>
      )}

      {estagiarios.length > 2 && (
        <div className="col-md-3">
          <label htmlFor="filtroestagiario" className="col-form-label">Estagiário:</label>
          {/*
            Mantém a visibilidade do seletor (baseada no tamanho da lista "estagiarios"),
            mas permite ocultar itens individualmente (ex.: acesso via token).
          */}
          {(() => {
            const visibleOptions = estagiarios.filter((o) => !(o as any).hidden);
            return (
          <Select
            id="filtroestagiario"
            options={visibleOptions}
            value={filtroEstagiario ? visibleOptions.find(a => a.value == filtroEstagiario) : null}
            onChange={(option) => {
              tableState.setCurrentPage(0);
              setFiltroEstagiario(option ? Number(option.value) : undefined);
            }}
          />
            );
          })()}
        </div>
      )}

      <div className="col-md-1 pt-4 mt-3 ms-auto">
        <div className="form-check form-switch" title="Listar estagiários com ou sem folhas.">
          <input
            id="com_folhas"
            type="checkbox"
            className="form-check-input"
            checked={comFolha}
            onChange={(e) => setComFolha(e.target.checked)}
          />
          <label htmlFor="com_folhas" className="form-check-label">Disponíveis</label>
        </div>
      </div>
    </div>
  );
}
